<template>
    <div class="container">
      <div class="white-frame">
        <div class="title-text mb-3">
          <b>Dados da Vistoria</b>
        </div>
    
        <div class="col-md-12" v-if="displayBotaoReplicar">
          <button 
            class="button-base-small btn-yellow font-small" 
            id="btnReplicar" 
            type="button" 
            @click="ReplicaVistoria"
          >
            Replicar dados do sinistro <i class="fa fa-clipboard marginRight20" aria-hidden="true"></i>
          </button>
        </div>
        <br>
    
        <location
          :value="businessLocationObject"
          @locationUpdated="handleLocationUpdates"
          :validationObject="getLocationValidationObject"
          locationSectionName="vistoria"
        >
          <template #otherFields>
            <div
              class="col-md-12"
              :class="{ 'field-required': isFieldInvalid('Nome') }"
            >
              <!--Contacto (obrigatório); -->
              <label for="contatoVistoria" class="form-label">Nome do Contato</label>
              <input
                id="contatoVistoria"
                v-model="objDTO.Vistoria.VistoriaLocal.Nome"
                class="form-control"
              />
            </div>
            <div
              class="col-md-6"
              :class="{ 'field-required': isFieldInvalid('Telefone') }"
            >
              <!--Telefone cel. (obrigatório); -->
              <label for="telefoneVistoria" class="form-label">Telefone</label>
              <imask-input
                id="telefoneVistoria"
                v-model="objDTO.Vistoria.VistoriaLocal.Telefone"
                :mask="phoneMask"
                :unmask="true"
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <!--E-mail (facultativo). -->
              <label for="emailVistoria" class="form-label">Email</label>
              <input
                id="emailVistoria"
                v-model="objDTO.Vistoria.VistoriaLocal.Email"
                class="form-control"
              />
            </div>
          </template>
        </location>
      </div>
    </div>
    </template>
    
    <script>
    import { IMaskComponent } from 'vue-imask';
    import Location from '../../shared/Location.vue';
    import { mapGetters } from 'vuex';
    import GenericLocation from '../../../utils/classes/GenericLocation';
    import { iMaskConfig, locationDefaultObject } from '../../../utils/constants';
    
    export default {
      name: 'DadosVistoria',
      components: { 
        Location, 
        'imask-input': IMaskComponent 
      },
      props: {
        validation: {
          type: Object,
          required: true,
        },
        displayBotaoReplicar: {
          type: Boolean,
          required: false,
          default: true
        },
      },
      data() {
        return {
          businessLocationObject: GenericLocation.createLocationFromObject(
            locationDefaultObject
          ),
          phoneMask: iMaskConfig.telemovel,
        };
      },
      computed: {
        ...mapGetters({ objDTO: 'getObjDTO' }),
        getLocationValidationObject() {
          // Verifica a existência de todos os objetos antes de acessá-los
          const vistoriaLocal = this.validation?.objDTO?.Vistoria?.VistoriaLocal || {};
          return {
            locationObject: {
              address: vistoriaLocal.Morada || {},
              number: vistoriaLocal.CodPostalLocalidade || {},
              countryId: vistoriaLocal.PaisId || {},
              countryDescription: vistoriaLocal.PaisDescription || {},
              stateId: vistoriaLocal.DistritoId || {},
              stateDescription: vistoriaLocal.DistritoDescription || {},
              cityId: vistoriaLocal.ConcelhoId || {},
              cityDescription: vistoriaLocal.ConcelhoDescription || {},
              localityId: vistoriaLocal.FreguesiaId || {},
              localityDescription: vistoriaLocal.FreguesiaDescription || {},
            },
          };
        },
      },
      created() {
        // Garante que os campos da vistoria estejam inicializados
        if (!this.objDTO.Vistoria) {
          this.objDTO.Vistoria = {};
        }
        
        if (!this.objDTO.Vistoria.VistoriaLocal) {
          this.objDTO.Vistoria.VistoriaLocal = {};
        }
        
        // Inicializa o número de vistoria se não estiver definido
        if (this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade === undefined) {
          this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade = '';
        }
        
        // Inicializa o telefone da vistoria se não estiver definido
        if (this.objDTO.Vistoria.VistoriaLocal.Telefone === undefined) {
          this.objDTO.Vistoria.VistoriaLocal.Telefone = '';
        }
        
        // Inicializa o nome da vistoria se não estiver definido
        if (this.objDTO.Vistoria.VistoriaLocal.Nome === undefined) {
          this.objDTO.Vistoria.VistoriaLocal.Nome = '';
        }
        
        // Inicializa o email da vistoria se não estiver definido
        if (this.objDTO.Vistoria.VistoriaLocal.Email === undefined) {
          this.objDTO.Vistoria.VistoriaLocal.Email = '';
        }
      },
      beforeMount() {
        this.businessLocationObject = new GenericLocation(
          this.objDTO.Vistoria.VistoriaLocal.Morada,
          this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade,
          this.objDTO.Vistoria.VistoriaLocal.PaisId,
          this.objDTO.Vistoria.VistoriaLocal.PaisDescription,
          this.objDTO.Vistoria.VistoriaLocal.DistritoId,
          this.objDTO.Vistoria.VistoriaLocal.DistritoDescription,
          this.objDTO.Vistoria.VistoriaLocal.ConcelhoId,
          this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription,
          this.objDTO.Vistoria.VistoriaLocal.FreguesiaId,
          this.objDTO.Vistoria.VistoriaLocal.FreguesiaDescription,
          this.objDTO.Vistoria.VistoriaLocal.Obs
        );
      },
      methods: {
        // Novo método helper para verificar se um campo é inválido
        isFieldInvalid(fieldName) {
          if (!this.validation || !this.validation.objDTO || !this.validation.objDTO.Vistoria || 
              !this.validation.objDTO.Vistoria.VistoriaLocal) {
            return false;
          }
          
          const field = this.validation.objDTO.Vistoria.VistoriaLocal[fieldName];
          return field && field.$invalid === true;
        },
        ReplicaVistoria() {
          this.businessLocationObject.address = this.objDTO.Sinistro.SinistroMorada;
          
          // Garante que o número no sinistro exista antes de replicar
          if (this.objDTO.Sinistro.SinistroMoradaNrPorta !== undefined && 
              this.objDTO.Sinistro.SinistroMoradaNrPorta !== null && 
              this.objDTO.Sinistro.SinistroMoradaNrPorta.trim() !== '') {
            this.businessLocationObject.number = this.objDTO.Sinistro.SinistroMoradaNrPorta;
          } else {
            // Define um valor padrão caso não exista
            this.businessLocationObject.number = 'S/N';
          }
    
          this.businessLocationObject.countryId = this.objDTO.Sinistro.SinistroPaisId;
          this.businessLocationObject.countryDescription = this.objDTO.Sinistro.SinistroPaisDescricao;
          this.businessLocationObject.stateId = this.objDTO.Sinistro.SinistroDistritoId;
          this.businessLocationObject.stateDescription = this.objDTO.Sinistro.SinistroDistritoDescripton;
          this.businessLocationObject.cityId = this.objDTO.Sinistro.SinistroConcelhoId;
          this.businessLocationObject.cityDescription = this.objDTO.Sinistro.SinistroConcelhoDescription;
          this.businessLocationObject.localityId = this.objDTO.Sinistro.SinistroFreguesiaId;
          this.businessLocationObject.localityDescription = this.objDTO.Sinistro.SinistroFreguesiaDescription;
          this.businessLocationObject.complement = this.objDTO.Sinistro.SinistroObs;
         
          // Também preencher o telefone se estiver disponível no sinistro
          if (this.objDTO.Sinistro.SinistroTelemovel) {
            this.objDTO.Vistoria.VistoriaLocal.Telefone = this.objDTO.Sinistro.SinistroTelemovel;
          }
          
          this.handleLocationUpdates(this.businessLocationObject);
        },
        handleLocationUpdates(locationObject) {
          this.objDTO.Vistoria.VistoriaLocal.Morada = locationObject.address;
          this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade = locationObject.number;
          this.objDTO.Vistoria.VistoriaLocal.PaisId = locationObject.countryId;
          this.objDTO.Vistoria.VistoriaLocal.PaisDescription = locationObject.countryDescription;
          this.objDTO.Vistoria.VistoriaLocal.DistritoId = locationObject.stateId;
          this.objDTO.Vistoria.VistoriaLocal.DistritoDescription = locationObject.stateDescription;
          this.objDTO.Vistoria.VistoriaLocal.ConcelhoId = locationObject.cityId;
          this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription = locationObject.cityDescription;
          this.objDTO.Vistoria.VistoriaLocal.FreguesiaId = locationObject.localityId;
          this.objDTO.Vistoria.VistoriaLocal.FreguesiaDescription = locationObject.localityDescription;
          this.objDTO.Vistoria.VistoriaLocal.Obs = locationObject.complement;
        },
      },
    };
    </script>
    
    <style scoped>
    /* Você pode adicionar estilos específicos aqui */
    </style>